export function unset(keys, state) {
  for(const key of keys) {
    localStorage.removeItem(key);
  }
}
